<mat-card class="about-card">
  <mat-card-header class="d-flex justify-content-center">
    <mat-card-title>Mapa</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div
      id="mapLayout"
      leaflet
      [leafletOptions]="options"
      (leafletMapReady)="onMapReady($event)"
      [(leafletLayersControl)]="layersControl"
      [(leafletZoom)]="zoom"
      [(leafletCenter)]="center"
    ></div>
  </mat-card-content>
  <mat-card-actions class="d-flex justify-content-center">
    <button
      mat-button
      [mat-dialog-close]="true"
      style="background-color: rgb(111, 194, 233)"
    >
      Ok
    </button>
  </mat-card-actions>
</mat-card>
